import { connectCurrentRefinements } from 'instantsearch.js/es/connectors'
import { amplitudeEventProperties, trackAmplitudeEvent } from '../../analytics/CustomEvents'
import { excludedAttributesForCurrentRefinements } from '../../utils/search/filters'
import { withoutLandingScopeCategoryRefinements } from '../../utils/search/categoryPaths'

function facetOf (tile) {
  return [tile.dataset.facetAttribute, tile.dataset.facetValue]
}

// Selecting is exclusive among the tiles; deselecting removes only that tile's filter.
// Other filter panel refinements are left alone. Returns whether the tile is now on.
export function applyTile (helper, tiles, clicked) {
  const turningOn = !helper.state.isDisjunctiveFacetRefined(...facetOf(clicked))

  if (turningOn) {
    tiles
      .filter(tile => helper.state.isDisjunctiveFacetRefined(...facetOf(tile)))
      .forEach(tile => helper.removeDisjunctiveFacetRefinement(...facetOf(tile)))
    helper.addDisjunctiveFacetRefinement(...facetOf(clicked))
  } else {
    helper.removeDisjunctiveFacetRefinement(...facetOf(clicked))
  }
  helper.search()

  return turningOn
}

function handleClick (runtime, helper, event) {
  const tile = event.target.closest('.vjs-browse-tile')
  if (!tile) return

  const tileFacets = runtime.tiles.map(other => facetOf(other).join(':'))
  const [facetAttribute, facetValue] = facetOf(tile)
  const properties = {
    ...amplitudeEventProperties(tile.dataset),
    facet_attribute: facetAttribute,
    facet_value: facetValue,
    had_existing_filters: runtime.appliedFilters.some(filter => !tileFacets.includes(filter))
  }
  const turnedOn = applyTile(helper, runtime.tiles, tile)
  const componentName = tile.dataset.amplitudeComponentName
  // A preview renders no tracking data.
  if (componentName) trackAmplitudeEvent(`${componentName} ${turnedOn ? 'Clicked' : 'Deselected'}`, properties)
}

function render (runtime, { items, instantSearchInstance }, isFirstRender) {
  if (isFirstRender) runtime.row.addEventListener('click', event => handleClick(runtime, instantSearchInstance.helper, event))

  runtime.appliedFilters = items.flatMap(item => item.refinements.map(refinement => `${refinement.attribute}:${refinement.value}`))
  runtime.tiles.forEach(tile => tile.setAttribute('aria-pressed', runtime.appliedFilters.includes(facetOf(tile).join(':'))))
}

// Reads the refinements the filter count does, so "existing filters" means what shoppers see counted.
export default function browseTilesWidget () {
  const row = document.querySelector('.vjs-browse-tiles')
  if (!row) return null

  const runtime = { row, tiles: Array.from(row.querySelectorAll('.vjs-browse-tile')), appliedFilters: [] }

  return connectCurrentRefinements((renderOptions, isFirstRender) => render(runtime, renderOptions, isFirstRender))({
    excludedAttributes: excludedAttributesForCurrentRefinements(),
    transformItems: withoutLandingScopeCategoryRefinements
  })
}
